import { createFileRoute } from '@tanstack/react-router';
import { influencerStaticData } from '../../../influencer';

export const Route = createFileRoute('/_private-routes/influencer/$id/$socialMediaAccountId/instagram_story_post')({
  staticData: influencerStaticData
});
